import { auth as en_auth } from "../en/auth";

/** auth — ES slice (63 keys). */
export const auth: Record<keyof typeof en_auth, string> = {
  auth_welcome_title: "Bienvenido",
  auth_welcome_subtitle: "Inicia sesión o crea una cuenta",
  auth_continue_with_email: "Continuar con correo",
  auth_or: "o",
  auth_signin_title: "Inicia sesión con tu correo",
  auth_signin_email_label: "Correo",
  auth_signin_email_placeholder: "tu@ejemplo.com",
  auth_signin_password_label: "Contraseña",
  auth_signin_password_placeholder: "Tu contraseña",
  auth_signin_button: "Iniciar sesión",
  auth_signin_loading: "Iniciando sesión...",
  auth_signin_forgot: "¿La olvidaste?",
  auth_signin_no_account: "¿No tienes una cuenta?",
  auth_signin_create_account: "Crear cuenta",
  auth_signup_email_title: "Crear cuenta",
  auth_signup_email_subtitle: "Escribe tu correo para empezar",
  auth_signup_already_have_account: "¿Ya tienes una cuenta?",
  auth_signup_password_title: "Crea una contraseña",
  auth_signup_password_subtitle: "Establece una contraseña para tu cuenta",
  auth_signup_password_label: "Contraseña",
  auth_signup_password_placeholder: "Mín. 8 caracteres",
  auth_signup_password_change: "Cambiar",
  auth_signup_button: "Crear cuenta",
  auth_signup_loading: "Creando cuenta...",
  auth_verify_title: "Verifica tu correo",
  auth_verify_subtitle: "Enviamos un código a {email}",
  auth_verify_resend: "¿No lo recibiste?",
  auth_verify_resend_button: "Reenviar",
  auth_verify_resent: "¡Código enviado!",
  auth_forgot_title: "Olvidé mi contraseña",
  auth_forgot_subtitle: "Escribe tu correo para restablecer tu contraseña",
  auth_forgot_button: "Enviar código",
  auth_forgot_loading: "Enviando código...",
  auth_forgot_back: "Volver a iniciar sesión",
  auth_reset_title: "Restablecer contraseña",
  auth_reset_subtitle: "Escribe el código enviado a {email}",
  auth_reset_password_label: "Nueva contraseña",
  auth_reset_button: "Restablecer contraseña",
  auth_reset_loading: "Restableciendo...",
  auth_change_email_title: "Cambiar correo",
  auth_change_email_subtitle: "Escribe tu nueva dirección de correo",
  auth_change_email_current: "Correo actual",
  auth_change_email_new_label: "Nuevo correo",
  auth_change_email_new_placeholder: "nuevo@ejemplo.com",
  auth_change_email_button: "Continuar",
  auth_change_email_loading: "Enviando código...",
  auth_change_email_verify_title: "Verifica tu identidad",
  auth_change_email_verify_subtitle: "Enviamos un código a {email}",
  auth_change_email_verify_new_title: "Verifica el nuevo correo",
  auth_change_email_verify_new_subtitle: "Enviamos un código a {email}",
  auth_change_email_done_title: "Correo actualizado",
  auth_change_email_done_subtitle: "Tu correo se cambió a {email}",
  auth_change_email_done_button: "Listo",
  auth_dashboard_title: "Panel",
  auth_dashboard_subtitle: "Has iniciado sesión",
  auth_dashboard_email: "Correo",
  auth_dashboard_user_id: "ID de usuario",
  auth_dashboard_email_verified: "Correo verificado",
  auth_dashboard_yes: "Sí",
  auth_dashboard_no: "No",
  auth_dashboard_signout: "Cerrar sesión",
  auth_loading: "Cargando...",
  auth_loading_session: "Cargando sesión...",
};
